<template>
	<div class="upgrade_popover_tips">
		<slot>
			<img src="~@/assets/img/live/upgrade_tips.png" alt="" class="upgrade_tips_img" />
			<div class="tips_title">当前为{{ versionText }}功能</div>
			<div class="tips_text">升级版本后可使用</div>
		</slot>
		<div class="btn_wrap">
			<div class="btn" @click="cancel">取消</div>
			<div class="btn confirm" @click="toBuy">升级</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import dateFormat from 'ourwill-feutil/common/dateFormat';
import { getValueForkey } from '@/constant/constantMap';
export default {
	props: {
		isPay: {
			type: Number,
			default: 2,
		},
		upgradeFunc: {
			type: [Function, undefined],
			default: undefined,
		},
		// 在直播间里面需要升级账号付费类型 而不是直播间类型
		upgradeUser: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState({
			userInfo: (state) => state.userInfo.user,
			isCompanyMode: (state) => state.company.isCompanyMode,
			companyInfo: (state) => state.company.info,
			activityUserPowerType: (state) => state.userPower.activityUserPowerType,
		}),
		type() {
			let isPay = this.isPay ? this.isPay : 2;
			// 严格来说企业版的购买版本不一定是9 如果后续添加了9对应的直播间版本，请更改该标记
			let obj = {
				1: '1',
				2: '13',
				3: '43',
				4: '164',
				9: '56',
			};
			return obj[isPay];
		},
		versionText() {
			let obj = {
				0: '免费版',
				1: '专业版',
				2: '旗舰版',
				3: '尊享版',
				9: '企业版',
			};
			return obj[this.isPay];
		},
		isFree() {
			if (this.isMajor || this.isFlagship || this.isFullview || this.isCompany) {
				return false;
			}
			return true;
		},
		isFlagship() {
			if (this.flagshipDue || this.flagshipNum) {
				return true;
			}
			return false;
		},
		flagshipDue() {
			if (!this.userInfo.id || !this.userInfo.userEmpower.flagshipType) {
				return '';
			}
			if (
				this.userInfo.userEmpower.flagshipDueDate &&
				this.timejudge(this.userInfo.userEmpower.flagshipDueDate)
			) {
				return `${dateFormat(this.userInfo.userEmpower.flagshipDueDate, 'YYYY-MM-DD')}`;
			}
			return '';
		},
		flagshipNum() {
			if (!this.userInfo.id || !this.userInfo.userEmpower.flagshipRemainingTimes) {
				return '';
			}
			return this.userInfo.userEmpower.flagshipRemainingTimes;
		},
		isMajor() {
			if (this.majorDue || this.majorNum) {
				return true;
			}
			return false;
		},
		majorDue() {
			if (!this.userInfo.id || !this.userInfo.userEmpower.professionalType) {
				return '';
			}
			if (
				this.userInfo.userEmpower.professionalDueDate &&
				this.timejudge(this.userInfo.userEmpower.professionalDueDate)
			) {
				return `${dateFormat(this.userInfo.userEmpower.professionalDueDate, 'YYYY-MM-DD')}`;
			}
			if (this.flagshipDue) {
				return this.flagshipDue;
			}
			return '';
		},
		majorNum() {
			if (!this.userInfo.id) {
				return '';
			}
			return this.userInfo.userEmpower.professionalRemainingTimes
				? this.userInfo.userEmpower.professionalRemainingTimes
				: '';
		},
		isComShip() {
			if (this.comShipDue) {
				return true;
			}
			return false;
		},
		comShipDue() {
			if (this.isSubCompany) {
				if (!this.companyInfo || !this.companyInfo.flagshipCompanyDueDate) {
					return '';
				}
				if (
					this.companyInfo.flagshipCompanyDueDate &&
					this.timejudge(this.companyInfo.flagshipCompanyDueDate)
				) {
					return `${dateFormat(this.companyInfo.flagshipCompanyDueDate, 'YYYY-MM-DD')}`;
				}
			}
			if (!this.userInfo.id || !this.userInfo.userEmpower.flagshipCompanyDueDate) {
				return '';
			}
			if (
				this.userInfo.userEmpower.flagshipCompanyDueDate &&
				this.timejudge(this.userInfo.userEmpower.flagshipCompanyDueDate)
			) {
				return `${dateFormat(this.userInfo.userEmpower.flagshipCompanyDueDate, 'YYYY-MM-DD')}`;
			}
			return '';
		},
		isComFullview() {
			if (this.comFullviewDue) {
				return true;
			}
			return false;
		},
		comFullviewDue() {
			if (this.isSubCompany) {
				if (!this.companyInfo || !this.companyInfo.fullviewCompanyDueDate) {
					return '';
				}
				if (
					this.companyInfo.fullviewCompanyDueDate &&
					this.timejudge(this.companyInfo.fullviewCompanyDueDate)
				) {
					return `${dateFormat(this.companyInfo.fullviewCompanyDueDate, 'YYYY-MM-DD')}`;
				}
			}
			if (!this.userInfo.id || !this.userInfo.userEmpower.fullviewCompanyDueDate) {
				return '';
			}
			if (
				this.userInfo.userEmpower.fullviewCompanyDueDate &&
				this.timejudge(this.userInfo.userEmpower.fullviewCompanyDueDate)
			) {
				return `${dateFormat(this.userInfo.userEmpower.fullviewCompanyDueDate, 'YYYY-MM-DD')}`;
			}
			return '';
		},
		isFullview() {
			if (this.fullviewNum || this.fullviewDueDate) {
				return true;
			}
			return false;
		},
		fullviewNum() {
			if (!this.userInfo.id || !this.userInfo.userEmpower.fullviewRemainingTimes) {
				return '';
			}
			return this.userInfo.userEmpower.fullviewRemainingTimes;
		},
		fullviewDueDate() {
			if (
				!this.userInfo.id ||
				!this.userInfo.userEmpower.fullviewDueDate ||
				!this.timejudge(this.userInfo.userEmpower.fullviewDueDate)
			) {
				return '';
			}
			return dateFormat(this.userInfo.userEmpower.fullviewDueDate, 'YYYY-MM-DD');
		},
		hasPayUpdateVersion() {
			// 可以升级旗舰版的版本
			return this.activityUserPowerType >= 1;
		},
		isInMyLive() {
			return this.$route.path.indexOf('mylive') > -1;
		},
	},
	methods: {
		...mapMutations({
			LIVE_UPDATE_DIALOG: 'LIVE_UPDATE_DIALOG',
		}),
		...mapActions({
			updateMajor: 'updateMajor',
		}),
		toBuy() {
			// 如果有外部定义方法，则使用外部
			if (this.upgradeFunc) {
				this.upgradeFunc();
				return;
			}
			// 先兼容一下，企业版
			if (this.isPay == 9) {
				const href = `${location.origin}/purchase/service?priceType=${this.type}`;
				window.open(href, '_blank');
				return;
			}
			// 这里要判断的东西比较多
			// 首先企业版直接弹窗
			// 如果有旗舰版升级条件，并且当前显示为旗舰版，则直接弹窗，否则跳转购买页
			// 这里要判断一下，是否在直播间里
			if (this.isInMyLive && this.isPay === 2 && this.hasPayUpdateVersion) {
				// 直播课 + 旗舰版 + 当前账号是旗舰版
				this.LIVE_UPDATE_DIALOG(true);
			} else if (this.isInMyLive && this.isPay === 2 && !this.upgradeUser) {
				// 直播课 + 旗舰版 + 当前账号不是旗舰版 + 不是升级账号
				this.updateMajor();
			} else {
				const href = `${location.origin}/purchase/service?priceType=${this.type}`;
				window.open(href, '_blank');
			}
		},
		cancel() {
			this.$emit('cancel');
		},
		// 到期时间判断
		timejudge(type) {
			let now = new Date();
			let date = new Date(type);
			let inter = parseInt((date.getTime() - now.getTime()) / 1000 / 60);
			return inter >= 0 ? true : false;
		},
		dateFormat(val) {
			if (!val) {
				return '——';
			} else {
				return dateFormat(val, 'YYYY-MM-DD');
			}
		},
	},
};
</script>
<style lang="less">
.upgrade_popover_tips {
	width: 100%;
	min-height: 130px;
	box-sizing: border-box;
	padding: 23px 16px;
	position: relative;
	.tips_title {
		width: 100%;
		font-size: 14px;
		color: #272924;
	}
	.tips_text {
		margin-top: 5px;
		width: 100%;
		font-size: 12px;
		color: #4e5969;
	}
	.btn_wrap {
		margin-top: 18px;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		justify-content: flex-end;
	}
	.btn {
		width: 44px;
		height: 24px;
		box-sizing: border-box;
		border-radius: 2px;
		border: 1px solid #dddddd;
		line-height: 24px;
		color: #323233;
		text-align: center;
		cursor: pointer;
		&.confirm {
			border-color: #165dff;
			background-color: #165dff;
			color: #ffffff;
		}
		& + .btn {
			margin-left: 8px;
		}
	}
	.upgrade_tips_img {
		position: absolute;
		width: 76px;
		right: 7px;
		top: 12px;
	}
}
</style>
